import { ComponentProps, PropsWithChildren } from 'react';
import clsx from 'clsx';

import styles from './section.module.css';

type Props = {
  fullWidth?: boolean;
} & ComponentProps<'div'>;

export const Section = ({ children, fullWidth, className, ...props }: PropsWithChildren<Props>) => {
  return (
    <section className={clsx([styles.container, fullWidth && styles.fullWidth, className])} {...props}>
      {children}
    </section>
  );
};
